import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'leaflet/dist/leaflet.css'
import './src/styles/styles.scss'
import 'animate.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import { wrapRootElement as wrapRootElementBrowser } from './src/wrapElements'
import { wrapPageElement as wrapPageElementBrowser } from './src/wrapElements'
import { store } from './src/redux/store'
import {
  reduxUpdateFiltersFromRouter,
  updatePolygonAction,
  updateCoordinatesAction,
  updateOffsetAction,
} from './src/redux/slices/propertiesSlice'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-checkbox-tree/lib/react-checkbox-tree.css'
import { GatsbyBrowser } from 'gatsby'

const OPERATION_TYPES: string[] = ['venta', 'alquiler', 'temporario']

// gatsby-browser.ts
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  const pathname = location.pathname
  const operation = pathname.includes('/alquiler')
    ? 'alquiler'
    : pathname.startsWith('/temporario')
      ? 'temporario'
      : 'venta'

  const defaultFilters = {
    operation: operation,
    location: [],
    type: [],
    environments: '',
    bedrooms: '',
    age: '',
    address: '',
    producer_id: '',
    is_starred_on_web: false,
    price: {
      type: '',
      priceMin: '',
      priceMax: '',
      is_off: false,
    },
    surface: {
      type: '',
      surfaceMin: '',
      surfaceMax: '',
    },
    environments_types: [],
    generals: [],
    services: [],
    specials: [],
    q: '',
  }

  // Siempre ejecutar el dispatch al entrar al home '/' sin importar el tenant
  if (pathname === '/') {
    store.dispatch(reduxUpdateFiltersFromRouter(defaultFilters))
    store.dispatch(updatePolygonAction([]))
    store.dispatch(updateCoordinatesAction([]))
    store.dispatch(updateOffsetAction(0))
    return
  } else {
    const match = OPERATION_TYPES.find((tipo) => location.pathname.includes(`/${tipo}`))

    // Si la URL es operación + un segmento extra (ej. /venta/chacra), puede venir de un
    // link de categoría que ya despachó el `type` correcto justo antes de navegar (ver
    // handlePropertyNavClick en header/*). onRouteUpdate corre en todo cambio de ruta y
    // antes pisaba ese filtro con `type: []` incondicionalmente, perdiéndolo. Acá solo
    // nos encargamos de normalizar `operation`, dejando `type` como haya quedado.
    const segments = location.pathname.split('/').filter(Boolean)
    const isCategoryPath = Boolean(match) && segments[0] === match && segments.length > 1

    const nextFilters: Partial<typeof defaultFilters> = {
      ...defaultFilters,
      operation: match ?? 'todas',
    }
    if (isCategoryPath) {
      delete nextFilters.type
    }

    store.dispatch(reduxUpdateFiltersFromRouter(nextFilters))
    store.dispatch(updatePolygonAction([]))
    store.dispatch(updateCoordinatesAction([]))
    store.dispatch(updateOffsetAction(0))
  }
}

export const wrapRootElement = wrapRootElementBrowser
export const wrapPageElement = wrapPageElementBrowser
